export const SETTINGS_ROUTES = {
    brand: {
        identity: '/settings/brand/identity',
        colorsAndStyles: '/settings/brand/colors-and-styles',
        typography: '/settings/brand/typography',
        brandVoice: '/settings/brand/brand-voice',
    },
    shopper: {
        promotions: '/settings/shopper/promotions',
        benefits: '/settings/shopper/benefits',
        banners: '/settings/shopper/banners',
        freeShipping: '/settings/shopper/free-shipping',
        giftWithPurchase: '/settings/shopper/gift-with-purchase',
        storeGeneral: '/settings/shopper/store-general',
        subscriptions: '/settings/shopper/subscriptions',
        payments: '/settings/shopper/payments',
        privacyAndRedirects: '/settings/shopper/privacy-and-redirects',
    },
    integrations: {
        pixels: '/settings/integrations/pixels',
        reviews: '/settings/integrations/reviews',
    },
    account: {
        team: '/settings/account/team',
        billing: '/settings/account/billing',
        domains: '/settings/account/domains',
        advanced: '/settings/account/advanced',
    },
} as const

export const SETTINGS_DEFAULT_ROUTES = {
    brand: SETTINGS_ROUTES.brand.identity,
    shopper: SETTINGS_ROUTES.shopper.promotions,
    integrations: SETTINGS_ROUTES.integrations.pixels,
    account: SETTINGS_ROUTES.account.team,
} as const

export type SettingsTopSection = keyof typeof SETTINGS_DEFAULT_ROUTES

const LEGACY_TAB_REDIRECTS: Record<string, string> = {
    settings: SETTINGS_ROUTES.brand.identity,
    voice: SETTINGS_ROUTES.brand.brandVoice,
    'color-schemes': SETTINGS_ROUTES.brand.colorsAndStyles,
    typography: SETTINGS_ROUTES.brand.typography,
    benefits: SETTINGS_ROUTES.shopper.benefits,
}

export const getLegacySettingsTabRedirect = (
    tab: string | string[] | undefined,
): string | null => {
    if (typeof tab !== 'string') {
        return null
    }
    return LEGACY_TAB_REDIRECTS[tab] ?? null
}

export const getSettingsTopSection = (
    pathname: string,
): SettingsTopSection | null => {
    if (pathname.startsWith('/settings/brand')) return 'brand'
    if (pathname.startsWith('/settings/shopper')) return 'shopper'
    if (pathname.startsWith('/settings/integrations')) return 'integrations'
    if (pathname.startsWith('/settings/account')) return 'account'
    return null
}

export const isSettingsPath = (pathname: string): boolean =>
    pathname === '/settings' || pathname.startsWith('/settings/')
